import { AdminUser, ProfileApprovalState } from '@models/auth';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { createSafeStorage, createSizePartialize } from '@utils/localStorage';

const PAGE_SIZE = 20;

interface AdminPartnerUsersStoreProps {
  searchResultContainer: {
    contents: AdminUser[];
    total: number;
    page: number;
    size: number;
    hasNext: boolean;
  };
  searchQuery: {
    page: number;
    size: number;
    keyword?: string;
    startDate?: string;
    endDate?: string;
    type?: string;
    profileStatus?: ProfileApprovalState | 'all';
    partnerFilter?: 'all' | 'selling' | 'not-selling' | 'no-products';
    excellentPartner?: 'all' | 'yes' | 'no';
    sort?: string;
    membership?: string;
  };
  setAdminPartnerUsersContainer: (result: {
    contents: AdminUser[];
    total: number;
    page: number;
    size: number;
    hasNext: boolean;
  }) => void;
  updateSearchQuery: (query: { [key: string]: any }) => void;
  setStartDate: (date: string | null) => void;
  setEndDate: (date: string | null) => void;
  resetSearchQuery: () => void;
}

export const useAdminPartnerUsersStore = create(
  persist<AdminPartnerUsersStoreProps>(
    (set) => ({
      searchResultContainer: {
        contents: [] as AdminUser[],
        total: 0,
        page: 0,
        size: PAGE_SIZE,
        hasNext: false,
      },
      searchQuery: {
        page: 0,
        size: PAGE_SIZE,
      },
      setAdminPartnerUsersContainer: (result) => {
        set((state) => {
          // 메모리 효율성을 위해 실제 데이터만 저장
          const newValue = {
            ...state.searchResultContainer,
            ...result,
            contents: result?.contents || [],
          };
          return { ...state, searchResultContainer: newValue };
        });
      },
      updateSearchQuery: (query) => {
        set((state) => {
          return {
            ...state,
            searchQuery: { ...state.searchQuery, ...query },
            searchResultContainer: { ...state.searchResultContainer, size: 0 },
          };
        });
      },
      setStartDate: (date: string | null) => {
        set((state) => {
          return {
            ...state,
            searchQuery: { ...state.searchQuery, startDate: date || undefined },
            searchResultContainer: { ...state.searchResultContainer, size: 0 },
          };
        });
      },
      setEndDate: (date: string | null) => {
        set((state) => {
          return {
            ...state,
            searchQuery: { ...state.searchQuery, endDate: date || undefined },
            searchResultContainer: { ...state.searchResultContainer, size: 0 },
          };
        });
      },
      resetSearchQuery: () => {
        set({
          searchQuery: {
            page: 0,
            size: PAGE_SIZE,
          },
        });
      },
    }),
    {
      name: 'igogo-admin-partner-users',
      storage: createSafeStorage(),
      partialize: createSizePartialize<AdminPartnerUsersStoreProps>(100),
    },
  ),
);
